import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import SportsEsportsIcon from "@material-ui/icons/SportsEsports";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import EventIcon from "@material-ui/icons/Event";
import SchoolIcon from "@material-ui/icons/School";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import GroupIcon from "@material-ui/icons/Group";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import StorefrontIcon from "@material-ui/icons/Storefront";
import FlightIcon from "@material-ui/icons/Flight";
import RestaurantIcon from "@material-ui/icons/Restaurant";
import FitnessCenterIcon from "@material-ui/icons/FitnessCenter";
import ComputerIcon from "@material-ui/icons/Computer";
import SecurityIcon from "@material-ui/icons/Security";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import GavelIcon from "@material-ui/icons/Gavel";
import EcoIcon from "@material-ui/icons/Eco";
import PaletteIcon from "@material-ui/icons/Palette";
import ChildCareIcon from "@material-ui/icons/ChildCare";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ForumIcon from "@material-ui/icons/Forum";
import ExtensionIcon from "@material-ui/icons/Extension";
import SearchIcon from "@material-ui/icons/Search";
import BubbleChartIcon from "@material-ui/icons/BubbleChart";
import HistoryIcon from "@material-ui/icons/History";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import MovieIcon from "@material-ui/icons/Movie";
import CakeIcon from "@material-ui/icons/Cake";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import LanguageIcon from "@material-ui/icons/Language";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import HotelIcon from "@material-ui/icons/Hotel";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import FavoriteIcon from "@material-ui/icons/Favorite";
import BrushIcon from "@material-ui/icons/Brush";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import ExploreIcon from "@material-ui/icons/Explore";
import StarIcon from "@material-ui/icons/Star";
import PetsIcon from "@material-ui/icons/Pets";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import BuildIcon from "@material-ui/icons/Build";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import HomeIcon from "@material-ui/icons/Home";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import MapIcon from "@material-ui/icons/Map";
import CasinoIcon from "@material-ui/icons/Casino";
import NightsStayIcon from "@material-ui/icons/NightsStay";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import PublicIcon from "@material-ui/icons/Public";
import CodeIcon from "@material-ui/icons/Code";
import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";

/** Catálogo de iconos para tipos de plantilla (id guardado en BD). */
export const TEMPLATE_CATEGORY_ICON_OPTIONS = [
	{ id: "label", label: "Etiqueta", Icon: LabelOutlinedIcon },
	{ id: "game", label: "Juego", Icon: SportsEsportsIcon },
	{ id: "corporate", label: "Corporativo", Icon: BusinessCenterIcon },
	{ id: "events", label: "Eventos", Icon: EventIcon },
	{ id: "learning", label: "Formación", Icon: SchoolIcon },
	{ id: "healthcare", label: "Salud", Icon: LocalHospitalIcon },
	{ id: "recruitment", label: "Reclutamiento", Icon: WorkOutlineIcon },
	{ id: "team", label: "Equipo", Icon: GroupIcon },
	{ id: "marketing", label: "Marketing", Icon: AnnouncementIcon },
	{ id: "sales", label: "Ventas", Icon: TrendingUpIcon },
	{ id: "retail", label: "Retail", Icon: StorefrontIcon },
	{ id: "tourism", label: "Turismo", Icon: FlightIcon },
	{ id: "beach", label: "Playa / ocio", Icon: BeachAccessIcon },
	{ id: "food", label: "Hostelería", Icon: RestaurantIcon },
	{ id: "sports", label: "Deporte", Icon: FitnessCenterIcon },
	{ id: "technology", label: "Tecnología", Icon: ComputerIcon },
	{ id: "code", label: "Programación", Icon: CodeIcon },
	{ id: "security", label: "Seguridad", Icon: SecurityIcon },
	{ id: "finance", label: "Finanzas", Icon: AccountBalanceIcon },
	{ id: "legal", label: "Legal", Icon: GavelIcon },
	{ id: "compliance", label: "Cumplimiento", Icon: VerifiedUserIcon },
	{ id: "environment", label: "Medio ambiente", Icon: EcoIcon },
	{ id: "energy", label: "Energía", Icon: FlashOnIcon },
	{ id: "culture", label: "Cultura", Icon: PaletteIcon },
	{ id: "design", label: "Diseño", Icon: BrushIcon },
	{ id: "kids", label: "Infantil", Icon: ChildCareIcon },
	{ id: "onboarding", label: "Onboarding", Icon: PersonAddIcon },
	{ id: "communication", label: "Comunicación", Icon: ForumIcon },
	{ id: "support", label: "Atención al cliente", Icon: HeadsetMicIcon },
	{ id: "puzzle", label: "Puzzle", Icon: ExtensionIcon },
	{ id: "mystery", label: "Misterio", Icon: SearchIcon },
	{ id: "horror", label: "Terror / noche", Icon: NightsStayIcon },
	{ id: "science", label: "Ciencia", Icon: BubbleChartIcon },
	{ id: "history", label: "Historia", Icon: HistoryIcon },
	{ id: "music", label: "Música", Icon: MusicNoteIcon },
	{ id: "cinema", label: "Cine", Icon: MovieIcon },
	{ id: "birthday", label: "Celebración", Icon: CakeIcon },
	{ id: "gift", label: "Regalo", Icon: CardGiftcardIcon },
	{ id: "remote", label: "Teletrabajo", Icon: HomeWorkIcon },
	{ id: "global", label: "Internacional", Icon: LanguageIcon },
	{ id: "world", label: "Mundo", Icon: PublicIcon },
	{ id: "innovation", label: "Innovación", Icon: EmojiObjectsIcon },
	{ id: "leadership", label: "Liderazgo", Icon: EmojiEventsIcon },
	{ id: "hospitality", label: "Hospitalidad", Icon: HotelIcon },
	{ id: "logistics", label: "Logística", Icon: LocalShippingIcon },
	{ id: "nonprofit", label: "Social / ONG", Icon: FavoriteIcon },
	{ id: "interactive", label: "Interactivo", Icon: TouchAppIcon },
	{ id: "escape", label: "Escape room", Icon: VpnKeyIcon },
	{ id: "explore", label: "Aventura", Icon: ExploreIcon },
	{ id: "map", label: "Mapa / ruta", Icon: MapIcon },
	{ id: "stars", label: "Destacado", Icon: StarIcon },
	{ id: "pets", label: "Mascotas", Icon: PetsIcon },
	{ id: "automotive", label: "Automoción", Icon: DirectionsCarIcon },
	{ id: "construction", label: "Construcción", Icon: BuildIcon },
	{ id: "realestate", label: "Inmobiliaria", Icon: HomeIcon },
	{ id: "community", label: "Comunidad", Icon: PeopleAltIcon },
	{ id: "fun", label: "Diversión", Icon: CasinoIcon },
	{ id: "shopping", label: "Compras", Icon: ShoppingCartIcon },
];

export function getTemplateCategoryIconOption(iconId) {
	return TEMPLATE_CATEGORY_ICON_OPTIONS.find((opt) => opt.id === String(iconId || "").trim())
		|| TEMPLATE_CATEGORY_ICON_OPTIONS[0];
}
